import { Box, Typography } from "@mui/material";
import React from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { totalRowTypeList } from "source/components/task/TaskTypeDialog/TaskTypeDialogFormDesigner/FormDesignerComponentProperties/FormDesignerComponentPropertiesRow";
import { TaskDataRowTotalType } from "ui/Scripts/source/models/enums";
import { ITaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";

const getRenderItem =
    (items: ITaskTypeCol[], fieldName: string, onClick: (id: string) => void, hasSummaryRow: boolean) =>
        // eslint-disable-next-line react/display-name
        (provided, _snapshot, rubric) =>
            (
                <div
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}
                    className={items[rubric.source.index].class.replace("d-none", "")}
                >
                    <Box
                        sx={{
                            border: "1px solid",
                            borderColor:
                                fieldName === items[rubric.source.index].field
                                    ? "text.primary"
                                    : "action.hover",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            width: "100%",
                        }}
                        onClick={() => onClick(items[rubric.source.index].field)}
                    >
                        <Box
                            sx={{
                                width: "100%",
                            }}
                        >
                            <Box
                                className="colValueContainer"
                                sx={{
                                    bgcolor: "action.hover",
                                    display: "flex",
                                    alignItems: "center",
                                    height: "42px",
                                    paddingLeft: ".25rem !important",
                                    paddingRight: ".25rem !important",
                                    width: "100%",
                                }}
                            >
                                <Typography>{items[rubric.source.index].title}</Typography>
                            </Box>
                            {hasSummaryRow &&
                                <Box
                                    className="colValueContainer"
                                    sx={{
                                        alignItems: "center",
                                        display: "flex",
                                        height: "42px",
                                        paddingLeft: ".25rem !important",
                                        paddingRight: ".25rem !important",
                                        width: "100%",
                                    }}
                                >
                                    <Typography>
                                        {items[rubric.source.index].lineTotalType === TaskDataRowTotalType.None
                                            ? ""
                                            : (items[rubric.source.index].lineTotalType === TaskDataRowTotalType.Text
                                                ? items[rubric.source.index].lineTotalExpression
                                                : `'${totalRowTypeList.find(i => i.id === items[rubric.source.index].lineTotalType.toString())?.title}'`
                                            )
                                        }
                                    </Typography>
                                </Box>
                            }
                        </Box>
                    </Box>
                </div>
            );

interface IFormDesignerBuilderRowBuilderProps {
    droppableId: string;
    taskType?: ITaskEditTypeItem;
    lineDataRow?: ITaskDataRow;
    lineTypeCol?: ITaskTypeCol;
    draggingSource?: string;
    onClick?: (id: string) => void;
}

export const FormDesignerBuilderRowBuilder = (
    props: IFormDesignerBuilderRowBuilderProps
) => {
    const items = props.taskType?.lineCols ?? [];
    const hasSummaryRow = !!items.find(i => i.lineTotalType !== TaskDataRowTotalType.None);
    const renderItem = getRenderItem(items, props.lineTypeCol?.field, props.onClick, hasSummaryRow);
    
    return (
        <Box sx={{ display: "flex" }}>
            <Droppable
                droppableId={props.droppableId}
                direction="horizontal"
                renderClone={renderItem}
                getContainerForClone={() => {
                    return document.getElementById("formDesignerDragItemContainerForRow") as any;
                }}
                isDropDisabled={props.draggingSource !== props.droppableId}
            >
                {(provided, _snapshot) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            width: "100%",
                            position: "relative",
                        }}
                        className="jsonFormLineData"
                    >
                        {props.taskType?.lineCols?.map((item, colIndex) => (
                            <Draggable
                                key={item.field}
                                draggableId={`${props.droppableId}${item.field}`}
                                index={colIndex}
                            >
                                {renderItem}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </Box>
    );
};
